import { SETTINGS_SERVICE } from "@/services/settings.service.js";

const state = {getSettingOutput: {}, putSettingOutput: false};

const actions = {
    //Service to get settings
    getSetting({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getSettingRequest');

        SETTINGS_SERVICE.getSetting()
            .then(
                output => {
                    commit('getSettingSuccess', output);
                },
                error => {
                    commit('getSettingFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update settings
    putSetting({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putSettingRequest');

        SETTINGS_SERVICE.putSetting(input)
            .then(
                output => {
                    commit('putSettingSuccess', output);
                },
                error => {
                    commit('putSettingFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getSetting
    getSettingRequest(state) {
    },
    getSettingSuccess(state, output) {
        state.getSettingOutput = output;
    },
    getSettingFailure(state) {
        state.getSettingOutput = false;
    },

    //putSetting
    putSettingRequest(state) {
        state.putSettingOutput = null;
    },
    putSettingSuccess(state, output) {
        state.putSettingOutput = true;
    },
    putSettingFailure(state) {
        state.putSettingOutput = false;
    },
};

export const settings = {
    namespaced: true,
    state,
    actions,
    mutations
};